export default __webpack_public_path__ + "static/media/helloblack.a88fea66.svg";